module.exports = __webpack_public_path__ + "img/Pista_16.664172fe.png";